import type { ButtonProps } from '@chakra-ui/react';
import { Button } from '@time-line/components/common';
import { useAddProductBundle } from 'hooks/cart/useAddProductBundle';
import { useOneClickCheckout } from 'hooks/useOneClickCheckout';
import type { ProductBundle } from 'types/cms/blocks';

interface CtaButtonProps
  extends Pick<ProductBundle, 'ctaType' | 'products'>, ButtonProps {
  size: 'sm' | 'md';
  colorScheme?: 'white' | 'gray';
  discountCodes?: string[];
}

export function CtaButton({
  ctaType,
  products,
  size,
  discountCodes,
  colorScheme = 'gray',
  ...props
}: CtaButtonProps) {
  const { goToOneClickCheckout, isPending: isCheckoutPending } =
    useOneClickCheckout({
      lines: products.map((product) => ({
        merchandiseId: product.variant.gid,
      })),
      discountCodes,
    });

  const { handleAddItemsToCart, isAddingItems, isAddingDiscount } =
    useAddProductBundle({ products, discountCodes });

  const defaultProps = {
    size,
    colorScheme,
    minWidth: '120px',
  };

  if (ctaType === 'checkout') {
    return (
      <Button
        className="button--checkout"
        {...defaultProps}
        isLoading={isCheckoutPending}
        onClick={goToOneClickCheckout}
        {...props}
      >
        Buy now
      </Button>
    );
  }
  return (
    <Button
      className="button--add-to-cart"
      {...defaultProps}
      onClick={handleAddItemsToCart}
      variant="primary"
      isLoading={isAddingItems || isAddingDiscount}
      {...props}
    >
      Add to cart
    </Button>
  );
}
